import { Timestamp } from '@angular/fire/firestore';

export interface AlbumImage {
  id: string | undefined;
  albumId: string | undefined;
  groupId: string | undefined;
  dominantColor: string | undefined;
  totalBytes: number | undefined;
  aspectRatio: string | undefined;
  layoutHint: LayoutHint | undefined;
  variants:
    | {
        ipad: string | undefined;
        mobile: string | undefined;
        original: string | undefined;
        laptop: string | undefined;
      }
    | undefined;
  created: Timestamp;
}

export enum LayoutHint {
  WIDE = 'wide',
  TALL = 'tall',
  SQUARE = 'square',
}
